import classNames from "classnames";
import { Field } from "redux-form";
import { isArray, isUndefined } from "lodash";
import { connect } from "react-redux";
import Help from "../Help";
import { maxLength, isLogged, isPublic, isNotLogged } from "../../CroUtils";
import TiptapHtmlEditor from "../../../../components/TiptapEditor";

const isRequired = ({ validate }) => {
  return isArray(validate)
    ? validate.some((fun) => fun.croName === "required")
    : false;
};

const required = (auth, fieldRest) =>
  (isNotLogged(auth) && !fieldRest.disabled) ||
  (isLogged(auth) && isPublic(auth) && !fieldRest.disabled) ||
  (isLogged(auth) && !isPublic(auth));

const renderHtmlEditor = ({ input, meta, disabled, variables, ...rest }) => (
  <div className={classNames("croField__html-editor", { "croField--error": meta.touched && meta.error })}>
    <TiptapHtmlEditor
      value={input.value}
      onChange={input.onChange}
      disabled={disabled}
      variables={variables}
      {...rest}
    />
    {meta.touched && meta.error && (
      <span className="error">{meta.error}</span>
    )}
  </div>
);

const CroTiptapEditor = ({
  className,
  title,
  labelStyle,
  helpEnum,
  maxlen,
  auth,
  variables,
  ...fieldRest
}) => (
  <label className={className}>
    <span className="title-row">
      <span
        className={classNames("title", {
          required: isRequired(fieldRest) && required(auth, fieldRest),
        })}
        style={labelStyle}
      >
        {title}
      </span>
      {!isUndefined(helpEnum) && (
        <span className="help-icon title-help-icon">
          <Help helpEnum={helpEnum} disabled={fieldRest.disabled} />
        </span>
      )}
    </span>
    <Field
      helpEnum={helpEnum}
      variables={variables}
      {...fieldRest}
      component={renderHtmlEditor}
      fullWidth
      normalize={
        fieldRest.normalize
          ? fieldRest.normalize
          : maxlen
          ? maxLength(maxlen)
          : maxLength(65535)
      }
    />
  </label>
);

const mapStateToProps = (state) => ({
  auth: state.sidebar.auth,
});

export default connect(mapStateToProps)(CroTiptapEditor);
